<script>
import {  common } from '@/mixins/common';
import {
  PostApiWithAuthorizationAction,
} from "../../../helpers/apiActions";

export default {
  name: 'PurchaseLabelDialog',
  components: {},
  props: {
    displayDialog: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true,
      default() {
        return {
          extendedOrderID: []
        }
      }
    },
    purchaseLabelData: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      packageTypes: [
        "Large Envelope or Flat",
        "Thick Envelope",
        "Flat Rate Padded Envelope",
        "Package",
        "Flat Rate Box",
        "Small Flat Rate Box",
        "Large Flat Rate Box",
        "Flat Rate Envelope",
        "Large Package",
        "Oversized Package"
      ],
      formFilter: {
        packageType: 'Package',
        packageWeight: 2,
        requireSignature: false,
        defaultService: '',
        packageInsurance: 0
      },
      disablePackageWeightField: true,
      disablePurchaseLabel: false,
      enablePackageInsuranceField: false
    }
  },
  mixins: [
    common
  ],
  methods: {
    getTotalAmount(order) {
      const orderAmount = parseFloat(order.orderAmount)
      const totalShippingFee = parseFloat(order.totalShippingFee)
      let totalAmount = (orderAmount + totalShippingFee).toFixed(2)
      return totalAmount.replace(".00", "")
    },
    PurchaseLabel() {
      let _vm = this
      _vm.disablePurchaseLabel = true
      return PostApiWithAuthorizationAction("admin/orders/print-shipping-label", {
        orders: _vm.data.OrderIds.split(','),
        extendedOrderIDs: _vm.data.extendedOrderID
      }).then(res => {
        if (res.status === "success") {
          let invoiceUrl = res.invoiceUrls[0]
          //window.open(invoiceUrl, "_blank");
          _vm.$root.$emit('display-invoice', {
            invoiceUrl
          })
         _vm.$root.$emit('close-purchase-label-dialog')
          _vm.$root.$emit('update-row-order', {
            index: _vm.data.index,
            attributes: {
              localPrinted: 1,
              shipmentTrackingNumber: res.labelData.tracking_number
            }
          })
        }
        _vm.disablePurchaseLabel = false
      })
    },
    editPackageWeight() {
      this.disablePackageWeightField = false
    },
    updateParticularOrder() {
      let _vm = this
      return PostApiWithAuthorizationAction("admin/orders/update-particular-order", {
        orders: _vm.data.OrderIds.split(','),
        extendedOrderIDs: _vm.data.extendedOrderID,
        ... _vm.formFilter
      }).then(() => {
        _vm.$root.$emit('reload-purchase-label-data', {
          orders: _vm.data.OrderIds.split(','),
          shippingParams: {
            packageInsurance: _vm.formFilter.packageInsurance,
            requireSignature: _vm.formFilter.requireSignature,
            packageType: _vm.formFilter.packageType,
            packageWeight: _vm.formFilter.packageWeight
          }
        })
      })
    },
    submitData() {
      let _vm = this
      let service = _vm.purchaseLabelData.rates.find(v => v.desc === _vm.formFilter.defaultService)
      return PostApiWithAuthorizationAction("admin/orders/saveShippingService", {
        orders: _vm.data.OrderIds.split(','),
        extendedOrderIDs: _vm.data.extendedOrderID,
        ... _vm.formFilter,
        service: service != -1 ? service.service_code : 'US-PS'
      }).then(res => {
        if (res.status === "success") {
          _vm.$toast.error(res.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true,
          });
        }
      })
    },
    getServices(defaultService) {
      let _vm = this
      // eslint-disable-next-line
      console.log(defaultService)
      let service = (typeof _vm.purchaseLabelData !== "undefined") ? _vm.purchaseLabelData.rates.find(v => v.service_code === defaultService) : { desc: ""}
      return service.desc
    },
    handleDialogClose() {
      this.$root.$emit('close-dialog', 'displayPurchaseLabelDialog')
    },
    setPackageInsuranceField() {
      if (this.enablePackageInsuranceField) {
        this.formFilter.packageInsurance = this.getTotalAmount(this.data)
      } else {
        this.formFilter.packageInsurance = null
      }
      this.updateParticularOrder()
    },
    setPackageType() {
      this.formFilter.defaultService = ""
      this.updateParticularOrder()
    }
  },
  computed: {
    limitExtendedOrders() {
      return this.data ? this.data.extendedOrderID.slice(0, 6) : []
    },
    ebayStoreUrl() {
      return process.env.NODE_ENV === "development"
        ? "http://sandbox.ebay.com"
        : "http://ebay.com";
    }
  },
  watch: {
    'order.shipmentTrackingNumber': function (val) {
      this.form.trackingNumber = val
    },
    'data.id': function (val) {
      this.formFilter.defaultService = this.getServices(this.data.defaultService)
      this.formFilter.itemWeightLb = this.purchaseLabelData.order.orderItemInOz
      this.formFilter.itemWeightOz = this.purchaseLabelData.order.orderItemInLb
      this.formFilter.requireSignature = this.purchaseLabelData.order.requireDeliverySignature
      this.formFilter.packageType = this.purchaseLabelData.order.defaultPackageType
      if (this.purchaseLabelData.order.packageInsurance > 0) {
        this.formFilter.packageInsurance = this.purchaseLabelData.order.packageInsurance
        this.enablePackageInsuranceField = true
      } else {
        this.enablePackageInsuranceField = false
      }
      this.selectedIndex = val
    }
  }
}
</script>

<template>
    <el-dialog
      custom-class="el-dialog-bs-info el-dialog-label-preview"
      :visible.sync="displayDialog"
      width="70%"
      @close="handleDialogClose">
      <span slot="title"><h5><i class="fas fa-print"></i> PRINT SHIPPING LABEL</h5></span>
      <b-row class="mx-0 px-0">
        <b-col cols="4">
          <div class="row p-0 m-0" v-if="limitExtendedOrders.length > 1">
            <b>Combined Orders :</b>
          </div>
          <div class="row p-0 m-0" v-if="limitExtendedOrders.length > 1">
            <el-link
              :underline="false"
              type="danger"
              class="display-inline font-weight-bold"
              style="width: auto; padding-right: 5px"
              target="_blank"
              v-for="(extendedOrderID, index) in limitExtendedOrders"
              :key="index"
              :href="'javascript:;'"
            >
              {{ extendedOrderID }}&nbsp;&nbsp;
            </el-link>
            <hr style="margin-top: 0;">
          </div>
          <div class="row p-0 m-0">
            <b-row class="mx-0 mb-1 px-0">
              <b-col cols="3" class="px-0"><div class="">Ship from /</div> <div class="">Return to</div></b-col>
              <b-col cols="9" class="">
                <div class="">{{  purchaseLabelData.fromAddress.companyName }}</div>
                <div class="">{{  purchaseLabelData.fromAddress.companyAddress }}</div>
                <div class="">{{  purchaseLabelData.fromAddress.companyCity }} {{  purchaseLabelData.fromAddress.companyState }} {{  purchaseLabelData.fromAddress.companyPostalCode }}</div>
              </b-col>
            </b-row>
            <b-row class="mx-0 px-0">
              <b-col cols="3" class="px-0 text-right">Ship to</b-col>
              <b-col cols="9" class="">
                <div class="">{{  purchaseLabelData.toAddress.name }}</div>
                <div class="">{{  purchaseLabelData.toAddress.address }}</div>
                <div class="">{{  purchaseLabelData.toAddress.city }} {{  purchaseLabelData.toAddress.state }} {{  purchaseLabelData.toAddress.postalCode }}</div>
              </b-col>
            </b-row>
          </div>
          <hr style="margin-top: 0;">
          <div class="row p-0 m-0">
            <b-row class="mx-0 mb-1 px-0">
              <b-col cols="3" class="text-right">Buyer</b-col>
              <b-col cols="9">
                <el-link
                  class="display-inline font-weight-400 text-transform: capitalize;"
                  :underline="false"
                  type="primary"
                  target="_blank"
                  :href="ebayStoreUrl + '/usr/' + purchaseLabelData.buyer.ebayUserId"
                >
                  {{  purchaseLabelData.buyer.firstname }} {{  purchaseLabelData.buyer.lastname }}
                </el-link>
              </b-col>
            </b-row>
            <b-row class="mx-0 mb-1 px-0">
              <b-col cols="3" class="text-right">Total</b-col>
              <b-col cols="8">
                <div class="">${{ getTotalAmount(data) }}</div>
              </b-col>
            </b-row>
            <hr style="margin-top: 0;">
          </div>
        </b-col>
        <b-col cols="8">
          <div class="mb-1">
            <el-form
              :model="formFilter"
              @submit.native.prevent="updateShippingDetail()"
              ref="formContainer"
              id="purchaseLabelForm">
              <div class="mx-0 mb-1 px-0 text-center">
                  <el-checkbox
                    v-model="enablePackageInsuranceField"
                    @change="setPackageInsuranceField()">
                    Add Package Insurance
                  </el-checkbox>&nbsp;&nbsp;
                  <el-checkbox
                    v-model="formFilter.requireSignature"
                    @change="updateParticularOrder()">
                    Require Signature at delivery
                  </el-checkbox>
              </div>
              <b-row class="mx-0 mb-1 px-0">
                <b-col cols="5">
                  <div class>
                    <label class="mb-0">Package Type</label>
                    <el-select
                      v-model="formFilter.packageType"
                      placeholder="Package Types"
                      class="mx-1"
                      style="width: 100% !important"
                      @change="setPackageType()"
                    >
                      <el-option
                        v-for="(packageType, index) in packageTypes"
                        :key="index"
                        :label="packageType"
                        :value="packageType"
                      ></el-option>
                    </el-select>
                  </div>
                  <small id="emailHelp" class="form-text text-muted" style="margin-top: 0;text-align: center;font-size: 85%;">
                    <span id="shipment-default-package-type" style="font-weight: bold">{{ formFilter.packageType }}</span> will be the default package type for this shipment.
                  </small>
                </b-col>
                <b-col cols="3">
                  <label class="mb-0">Package Weight</label>
                  <el-input
                    :placeholder="'Package Weight'"
                    style="width: auto"
                    v-model="formFilter.packageWeight"
                    :disabled="disablePackageWeightField"
                    @change="updateParticularOrder()"
                  >
                  <el-button
                    slot="append"
                    icon="fas fa-pencil-alt"
                    v-if="disablePackageWeightField"
                    type="success"
                    @click="editPackageWeight()"></el-button>
                </el-input>
                </b-col>
                <b-col cols="3" v-if="enablePackageInsuranceField">
                  <label class="mb-0">Package Insurance</label>
                  <el-input
                    :placeholder="'Package Insurance'"
                    style="width: auto"
                    v-model="formFilter.packageInsurance"
                  ></el-input>
                </b-col>
              </b-row>
            </el-form>
          </div>
          <div class="mb-1">
            <b-row class="mx-0 mb-1 px-0">
              <b-col cols="3">
                <label class="mb-0">Item Weight</label>
                <el-input placeholder="" v-model="formFilter.itemWeightLb" disabled>
                  <template slot="append">lb</template>
                </el-input>
              </b-col>
              <b-col cols="3">
                <label class="mb-0">&nbsp;</label>
                <el-input placeholder="" v-model="formFilter.itemWeightOz" disabled>
                  <template slot="append">oz</template>
                </el-input>
              </b-col>
              <b-col cols="6">
                <div class="mb-1">
                  <label class="mb-0">Shipping Service</label>
                  <el-select
                    v-model="formFilter.defaultService"
                    placeholder="Package Types"
                    style="width: 100% !important"
                    @change="submitData()"
                  >
                    <el-option
                      v-for="(rate, index) in purchaseLabelData.rates"
                      :key="index"
                      :label="rate.desc + ' ($' + rate.rate + ')'"
                      :value="rate.desc"
                    ></el-option>
                  </el-select>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="text-right">
            <el-button
              type="primary"
              :disabled="disablePurchaseLabel || formFilter.defaultService ===''"
              @click="PurchaseLabel()">
              <i class="fas fa-shopping-cart"></i> PURCHASE
            </el-button>
          </div>
          <!--el-table
            :data="purchaseLabelData.rates"
            class="purchaseDataTable"
            style="width: 100%">
            <el-table-column
              label="Service"
              width="400"
              >
              <template slot-scope="scope">
                {{ scope.row.desc }}
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Est. delivery"
              >
              N/A
            </el-table-column>
            <el-table-column
              prop="name"
              label="Price"
              >
              <template slot-scope="scope">
                ${{ scope.row.rate }}
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="Actions"
              >
              <template slot-scope="scope">
                <el-radio
                  v-model="formFilter.defaultService"
                  :label="scope.row.desc"
                  size="small"
                  class="mt-1"
                  border></el-radio>
              </template>
            </el-table-column>
          </el-table-->
        </b-col>
      </b-row>
      <span slot="footer" class="dialog-footer text-center pb-0">
        <!--el-button
          type="danger"
          class="mb-1"
          @click="submitData()">SAVE</el-button-->
      </span>
    </el-dialog>
</template>

<style>
  #purchaseLabelForm label {
    line-height: 10px !important
  }
  .purchaseDataTable .el-radio__label {
    display: none !important;
  }
  .purchaseDataTable {
    border: 5px solid #5b5f70 !important;
  }
  .purchaseDataTable th.el-table__cell {
    padding-top: 2px !important;
    padding-bottom: 0px;
    background: #74788d !important;
    color: white !important;
  }
  .purchaseDataTable td.el-table__cell {
    vertical-align: middle;
    padding-top: 0px !important;
    padding-bottom: 0px;
  }
</style>
